import React from 'react';

import { FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { CompanyOverview } from './CompanyOverview';
import { FinancialInfoOverview } from './FinancialInfoOverview';
import { FundingNeedsOverview } from './FundingNeedsOverview';
import { MarketOverview } from './MarketOverview';
import { ProjectOverview } from './ProjectOverview';
import { IForInvestorFormSubSections } from '../forInvestorsSections';

const SUB_SECTIONS: IForInvestorFormSubSections = {
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW.COMPANY]: CompanyOverview,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW.PROJECT]: ProjectOverview,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW.MARKET_CUSTOMERS]: MarketOverview,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW.FINANCIAL_INFO]: FinancialInfoOverview,
  [FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_OVERVIEW.FUNDING_NEEDS]: FundingNeedsOverview,
};

export const Overview: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
